import { CheckIcon } from '@heroicons/react/24/solid';

import { Plan, SubscriptionType } from './release-log-plans';

const PlanCard = ({
  plan: {
    type,
    price,
    description,
    benefitHeading,
    visitorCount,
    benefits,
    active,
  },
  selectedSubscriptionType,
}: {
  plan: Plan;
  selectedSubscriptionType: SubscriptionType;
}) => {
  return (
    <div className="dark:bg-primaryDeep flex flex-grow  basis-0  flex-col rounded-lg  border-2 border-gray-200">
      <div className="px-8 pb-4 pt-8">
        <p className="mb-4 inline-block rounded-full bg-[#ffe4d2] px-4 py-0  font-medium text-[#FF914D]">
          {type}
        </p>
        <h3 className="mb-4 text-6xl font-extrabold">
          {selectedSubscriptionType === 'Monthly' ? price.month : price.year}
          <span className="text-2xl font-medium text-gray-500  dark:text-white">
            per-month
          </span>
        </h3>
        <h4 className="text-lg font-normal  leading-7">{description}</h4>
      </div>
      <div className="bg-[#ffe4d2] pb-8 pt-6">
        <p className="text-center text-xl font-bold text-[#FF914D]">
          {visitorCount}
        </p>
        <p className="text-center text-base  font-medium text-[#FF914D]">
          visitors
        </p>
      </div>
      <div className=" px-8 pb-4 pt-8">
        <p className=" mb-6 text-base font-bold">{benefitHeading}</p>

        <ul className="flex flex-col gap-y-6">
          {benefits.map((benefit, index) => (
            <li key={index} className=" flex items-center">
              <div className="mr-2">
                <CheckIcon className=" h-6 w-6 text-green-500 " />
              </div>
              <div>
                <p className="text-base font-medium">{benefit}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-grow flex-col justify-end px-8 pb-4 pt-8">
        <button
          disabled={!active}
          className="disabled:bg-sky-200 w-full rounded-md border border-transparent bg-[#FF914D] px-4 py-3 text-center text-sm font-medium text-white "
        >
          {active ? 'select-button-tex' : 'Coming Soon'}
        </button>
      </div>
    </div>
  );
};

export default PlanCard;
